<template>
  <div>
    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="dialog2" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="dialog2 = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

    <insertForm v-if="showForm" :formSchema="formSchema" v-on:emitForm="close"></insertForm>

    <v-card-title>
      <h2>Account Information</h2>
      <v-spacer></v-spacer>
      <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
    </v-card-title>

    <span style="display:none;">{{serial=serialNumber}}</span>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :pagination.sync="pagination"
      :total-items="totalDesserts"
      :loading="loading"
      class="elevation-4"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{serial++}}</td>
        <!-- <td class="text-xs-left">{{ props.item.project_name }}</td> -->
        <td class="text-xs-left">{{ props.item.eco_account_name }}</td>
        <td class="text-xs-left">{{ props.item.eco_account_code }}</td>
        <td class="text-xs-left">{{ props.item.account_type }}</td>        
        <td class="text-xs-left">
          <span v-if="props.item.is_active" class="active">Yes</span>
          <span v-else class="in-active">No</span>
        </td>
        <td class="justify-center layout px-0">

          <v-btn icon class="mx-0" v-if="userRole.updateButton" @click="editItem(props.index, props.item)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          
          <v-btn icon class="mx-0" v-if="userRole.deleteButton" @click="deleteItem(props.index, props.item.id)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>

          <v-btn v-if="props.item.projectDoc_id" icon class="mx-0" @click="downloadFile(props.item.document_file_name)">
            <v-icon color="purple">image</v-icon>
          </v-btn>
          <v-btn v-else icon disabled class="mx-0" title="Empty File">
            <v-icon color="purple">image</v-icon>
          </v-btn>

        </td>
      </template>
    </v-data-table>
  </div>
</template>


<script>

const commonService = require("../../../services/common.service");
import insertForm from "./insertForm";
import ServerPath from "../../../server-path/server-path";

import Axios from "axios";

export default {
  components: {
    insertForm
  },

  data: () => ({
    valid: true,
    showForm:false,

    /*------------- Datatable ---------------*/
    serialNumber: 0,
    sort: "",
    queryData: {
      sortBy: "id",
      descending: true,
      page: 1,
      rowsPerPage: 5,
      totalItems: 0,
      search_val: ""
    },

    search: "",
    totalDesserts: 0,
    desserts: [],
    loading: true,
    pagination: {},

    headers: [
      {
        text: "SL",
        value: ""
      },      
      /*{
        text: "Project Name",
        align: "left",
        sortable: true,
        value: "project_name"
      },*/
       {
        text: "Account Name",
        align: "left",
        sortable: true,
        value: "eco_account_name"
      },
      {
        text: "Account Number",
        align: "left",
        sortable: true,
        value: "eco_account_code"
      },           
      {
        text: "Account Type",
        align: "left",
        sortable: true,
        value: "account_type"
      },      
      {
        text: "Active",
        align: "left",
        sortable: true,
        value: "is_active"
      },

      { text: "Action", align: "center", value: "" }
    ],
    /*------------- /Datatable ---------------*/

    delete_id: "",
    row_index: "",
    dialog2: false,

    SnackbarVal: {
        snackbar: false,
        color: "success",
        message: ""
      },

    formSchema: {
      id: 0,
      eco_account_code: "",
      eco_account_name: "",
      category:"",
      address:"",
      remarks:"",
      account_type: "",
      account_with:'',      
      is_active:0,

      projectDoc_id:0,
      document_file_name:'',

    }
  }),

  /*------------Datatable------------*/
  watch: {
    params: {
      handler() {
        this.getDataFromApi().then(data => {
          this.desserts = data.items;
          this.totalDesserts = data.total;
        });
      },
      deep: true
    },

    userRole: function(){}
  },
  
  computed: {
    params(nv) {
      return {
        ...this.pagination,
        query: this.search
      };
    },

    userRole() {      
      let role = this.$store.getters.get_USER_ROLE_DATA;
      this.showForm = role.saveButton;
      return role;
    }
  },
  /*------------/Datatable------------*/

  methods: {
    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let search = this.search.trim().toLowerCase();

        let query_Data = this.queryData;

        (query_Data.sortBy = "id"),
          (query_Data.descending = this.pagination.descending),
          (query_Data.page = this.pagination.page),
          (query_Data.rowsPerPage = this.pagination.rowsPerPage),
          (query_Data.search_val = this.search);

        const serialNumber =
          this.pagination.rowsPerPage * this.pagination.page -
          this.pagination.rowsPerPage;
        this.serialNumber = serialNumber + 1;

        commonService
          .getServerSideData(query_Data, "account-info-list")
          .then(res => {
            let items = res.data;
            const total = res.totalRecords;
            if (search) {
              items = items.filter(item => {
                return Object.values(item)
                  .join(",")
                  .toLowerCase()
                  .includes(search);
              });
            }

            if (this.pagination.sortBy) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy];
                const sortB = b[sortBy];

                if (descending) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total
              });
            }, 300);
          });
      });
    },

    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    editItem(index, item) {
      this.row_index = index;      
      this.formSchema = {...item};
      window.scrollTo({
        top: 0,
        left: 100,
        behavior: "smooth"
      });
      this.showForm = true;
    },

    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.dialog2 = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "account-info").then(res => {
        if (res.status == 1) {
          this.desserts.splice(row_index, 1);
          this.getDataFromApi();
          this.SnackbarVal.color = "success"; 
        }
        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;

        this.confirmModel = false;
        this.dialog2 = false;
      });
    },

    downloadFile(fileName) {
      let url = ServerPath.serverPath+fileName;
       window.open(url);      
    },

    close(res) {
      let $this = this;

      if (res.status == 1) {
        if (res.action == "add") {
          $this.desserts.unshift({ ...res.data });
          $this.totalDesserts += 1;
        }
        if (res.action == "edit") {          
          $this.$set($this.desserts, $this.row_index, { ...res.data })
          this.row_index = "";
        }
        window.scrollTo({
          left: 0, top: document.body.scrollHeight || document.documentElement.scrollHeight, behavior: "smooth"
        });
        
        this.SnackbarVal.color = "success"; 
      }
      else
      {
        this.SnackbarVal.color = "error"; 
      }
      this.SnackbarVal.message = res.message;
      this.SnackbarVal.snackbar = true;      
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/project_info/account_info/dataTable.vue